import {
  type IoConfig,
  type NsHostTypeSlotId,
  type WithIoConfig,
  type WithNsHostTypeSlot,
} from '@blaze-runtime/engine-domain';

import { registerElementDefinition } from '../../services/element-definitions.service';

import { NavBottombarComponent } from './nav-bottombar.component';

// Extend the CanvasElementDefinitions type
declare module '@blaze-runtime/engine-domain' {
  interface CanvasElementDefinitions {
    navBottombar: NavBottombarDef;
  }
}

export const NAV_BOTTOMBAR_HOST_SLOT: NsHostTypeSlotId = 'nsHostType:Bottombar';
export type NavBottombarDef = WithNsHostTypeSlot & WithIoConfig;

registerElementDefinition({
  type: 'navBottombar',
  componentType: NavBottombarComponent,
  isListed: true,

  /**
   * Footer and Bottombar are not the same!!
   * Footer is used for common content that is kept at the bottom of page
   * and Bottombar for content at the end of viewport.
   * To make name fit into 2 lines we decided to keep "Navigation Footer"
   * instead of "Navigation Bottom Bar".
   */
  name: 'Navigation Footer',
  width: { mode: 'full' },
  height: { mode: 'auto' },
  slots: {
    ids: [NAV_BOTTOMBAR_HOST_SLOT],
    [NAV_BOTTOMBAR_HOST_SLOT]: {
      children: [],
      hosting: {},
    },
  },
  ioConfig: getIoConfig(),
  tags: ['Nav Menu', 'Bottom Bar', 'Footer'],
  groups: ['navigation'],
  version: 1,
});

function getIoConfig(): IoConfig {
  return {
    inputs: [
      {
        name: 'visible',
        bindingDefs: [{ property: 'visible', label: 'Is Visible', dataType: 'Boolean' }],
      },
    ],
    outputs: [],
  };
}
